import { render, staticRenderFns } from "./InvPorCategoria.vue?vue&type=template&id=3daac150&"
import script from "./InvPorCategoria.vue?vue&type=script&lang=js&"
export * from "./InvPorCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports